<template>
  <div class="w-full min-h-screen overflow-x-hidden overflow-y-auto bg-white" :class="showSpinner ? 'opacity-25' : ''">
    <div class="flex flex-1 h-screen">
      <main class="flex-1 h-full min-w-0 px-4 pt-4 overflow-x-hidden overflow-y-auto sm:pt-12 2xl:pt-2 lg:px-16 2xl:px-60 lg:flex"><div class="hidden lg:block w-96"></div>
        <section aria-labelledby="primary-heading" class="flex flex-col flex-1 h-full min-w-0 overflow-x-visible pt-14 lg:pt-0 lg:order-last">
          <ParticipantInfo>
            <template v-slot:header>
              <h1 class="px-4 mt-6 text-3xl text-darkBlue lg:mt-16">
                {{ $t('doc.acknowledge.header', { title: documentInfo?.displayText || documentInfo?.title }) }}
              </h1>
            </template>

            <template v-slot:description>
              <h3 class="px-4 mt-4 mb-10 text-base font-normal whitespace-pre-wrap text-darkBlue md:text-xl">
                {{ documentInfo?.description }}
              </h3>
            </template>

            <template v-slot:content>
              <DocumentAcknowledgement v-if="documentLoaded" :docInfo="documentInfo" @save="proceedToNext" @back="returnToPrevious" />
            </template>
          </ParticipantInfo>
          <VideoHelpButton v-if="documentInfo.videoLink" :video-link="documentInfo.videoLink"></VideoHelpButton>
        </section>
      </main>
      <AppSideNavMenu :participantDetails="participant" :slide="slideName" :id="enrollmentId"/>
    </div>
  </div>
  <GenesysChat></GenesysChat>

  <!-- Spinner -->
  <div class="fixed flex justify-center my-3 text-gray-500 left-1/2 top-1/2" v-if="showSpinner">
    <svg class="h-8 mr-3 -ml-1 animate-spin w-7 text-gtBlue600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>
</template>

<script>
import ParticipantInfo from 'Views/EnrollmentPresentation/StaticScreens/participant_info.vue';
import DocumentAcknowledgement from 'Views/EnrollmentPresentation/TemplateInstances/documentAcknowledgement.vue';
import enrollmentService from 'Services/backend/enrollments';
import documentService from 'Services/backend/documents';
import { getEnrolleeInitials } from 'Utilities/helper';
import routingService from "@/services/routingService";
import GenesysChat from "@/views/Shared/GenesysChat.vue";
import {useEnrollmentStore} from "@/stores/enrollment";
import {mapState, mapActions} from "pinia";

export default {
  components: {
    GenesysChat,
    ParticipantInfo,
    DocumentAcknowledgement,
  },
  mounted() {
    this.enrollmentId = this.$route.params.enrollmentId;
    this.enrolleeId = this.$route.params.enrolleeId;
    this.enrolleeType = this.$route.params.enrolleeType;
    this.docId = parseInt(this.$route.params.documentId);
    this.getDocumentInformation();
  },

  data() {
    return {
      participant: {
        firstName: '',
        lastName: '',
      },
      enrollmentId: '',
      enrolleeId: '',
      slideName: 'State Documents',
      showSpinner: true,
      enrolleeType: '',
      docId: '',
      documentInfo: {},
      documentLoaded: false,
      packets: {}
    };
  },

  methods: {
    getEnrolleeInitials,
    proceedToNext(acknowledgement) {
      if (this.showSpinner) return;
      const body = {
        enrolleeId: parseInt(this.enrolleeId),
        isAcknowledged: acknowledgement,
      };
      enrollmentService.documentAcknowledgment(this.docId, body).then(
        () => {
          const routeToDocumentId = routingService.getDocumentRouteId(this.packets,'stateDocuments', this.docId, 1);
          const routeInfo = routingService.determineAcknowledgementRoute(this.documentInfo.docFile, 'state', routeToDocumentId, this.docId);
          routingService.executeRoute(this.$router, routeInfo.route, this.enrollmentId, this.enrolleeId, this.enrolleeType, routeInfo.docId);
        },
        (error) => {
          console.error(error);
        },
      );
    },
    returnToPrevious() {
      if (this.showSpinner) return;
      const routeToDocumentId = routingService.getDocumentRouteId(this.packets,'stateDocuments', this.docId, -1);
      routingService.executeRoute(this.$router, routeToDocumentId ? 'stateFormFields' : routingService.determineEsignRoute(this.packets, 5), this.enrollmentId, this.enrolleeId, this.enrolleeType, routeToDocumentId || 0);
    },
    ...mapActions(useEnrollmentStore, ['loadEnrollees']),
    getDocumentInformation() {
      documentService.getDocumentById(this.docId, this.enrolleeId).then(
        (response) => {
          this.documentInfo = response.data;
          this.documentLoaded = true;
        },
        (error) => {
          console.error(error);
        },
      );
    }
  },

  computed: {
    ...mapState(useEnrollmentStore, ['getEnrollees', 'getFullPacket']),
  },

  watch: {
    getEnrollees(newEnrollees) {
      if (newEnrollees) {
        this.showSpinner = false;
        this.participant = getEnrolleeInitials(newEnrollees,this.enrolleeType) 
      }
    },
    getFullPacket(newPacket) {
      this.packets = newPacket;
    },
  },

  async created() {
    this.enrolleeId = this.$route.params.enrolleeId;
    await this.loadEnrollees(this.$route.params.enrolleeId);
  },
};
</script>

<style></style>
